import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import About from '../components/About/Main'
import BlogDetails from '../components/Blog/BlogDetails/Main'
import Blogs from '../components/Blog/Blogs/Main'
import Contact from '../components/Contact/Main'
import Footer from '../components/Footer/Main'
import Home from '../components/Home/Main'
import Home2 from '../components/Home2/Main'
import Home3 from '../components/Home3/Main'
import Navbar from '../components/Navbar/Main'
import Projects from '../components/Project/Projects/Main'
import JobDetails from '../components/Careers/JobDetails/Main'
import GraduateCareers from '../components/Careers/GraduateCareers/Main'
import WorkingAtBeet from '../components/Careers/WorkingAtBeet/Main'
import Culture from '../components/Careers/Culture/Main'
import Benefits from '../components/Careers/Benefits/Main'
import CyberSecurity from '../components/Services/CyberSecurity/Main'
import InfrastructurePlan from '../components/Services/InfrastructurePlan/Main'
import ITConsultant from '../components/Services/ITConsultant/Main'
import ITManagement from '../components/Services/ITManagement/Main'
import QATesting from '../components/Services/QATesting/Main'
import Service1 from '../components/Services/Services1/Main'
import Service2 from '../components/Services/Services2/Main'
import Team from '../components/Team/Main'
import MobileApplication from '../components/Services/MobileApplication/Main'
import SoftwareDevelopment from '../components/Services/SoftwareDevelopment/Main'
import DevOps from '../components/Services/DevOps/Main'
import AgileMethods from '../components/Services/AgileMethods/Main'

const Routing = () => {
    const [homePage, setHomePage] = useState(false)
    const location = useLocation();
    useEffect(() => {
      if (location.pathname === "/home-02" || location.pathname === "/home-03") {
          setHomePage(false)
      }else{
          setHomePage(true)
      }
    }, [location])
    
    return (
        <>
            {homePage && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/team" element={<Team />} />
                <Route path="/services" element={<ITConsultant />} />
                <Route path="/cyber-security" element={<CyberSecurity />} />
                <Route path="/it-management" element={<ITManagement />} />
                <Route path="/mobile-application-development" element={<MobileApplication />} />
                <Route path="/software-development" element={<SoftwareDevelopment />} />
                <Route path="/devops" element={<DevOps />} />
                <Route path="/agile-methodologies" element={<AgileMethods />} />
                <Route path="/qa-testing" element={<QATesting />} />
                <Route path="/infrastructure-plan" element={<InfrastructurePlan />} />
                <Route path="/it-consultant" element={<ITConsultant />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/job-details/:slug" element={<JobDetails />} />
                <Route path="/careers" element={<Blogs />} />
                <Route path="/graduate-careers" element={<GraduateCareers />} />
                <Route path="/working-at-beettechnologies" element={<WorkingAtBeet />} />
                <Route path="/beettechnologies-culture" element={<Culture />} />
                <Route path="/beettechnologies-benefits" element={<Benefits />} />
                <Route path="/blog-details" element={<BlogDetails />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
        </>
    )
}

export default Routing